import { Entity } from '@hglobal/fin-ui';

export interface Currency extends Entity<string> {
  createdAt: string;
  icon: string;
  isCrypto: boolean;
  minAmount: string;
  name: string;
  network: string;
  symbol: string;
  updatedAt: string;
  decimals: number;
}

export const DEFAULT_CURRENCY = 'USD';
